(() => {
  const parseLocalizedNumber = (value) => {
    const normalized = String(value)
      .replace(/[\s\u00a0\u202f]/g, '')
      .replace(/[^0-9,.-]/g, '');
    const lastDot = normalized.lastIndexOf('.');
    const lastComma = normalized.lastIndexOf(',');
    let decimalIndex = -1;

    if (lastDot >= 0 && lastComma >= 0) {
      decimalIndex = Math.max(lastDot, lastComma);
    } else {
      const separatorIndex = Math.max(lastDot, lastComma);
      const decimalLength = separatorIndex >= 0 ? normalized.length - separatorIndex - 1 : 0;
      if (decimalLength > 0 && decimalLength <= 2) decimalIndex = separatorIndex;
    }

    if (decimalIndex < 0) return Number(normalized.replace(/[.,]/g, ''));

    const integer = normalized.slice(0, decimalIndex).replace(/[.,]/g, '');
    const decimals = normalized.slice(decimalIndex + 1).replace(/[.,]/g, '');
    return Number(`${integer}.${decimals}`);
  };

  const detectCurrency = (value) => {
    if (value.includes('£')) return 'GBP';
    if (value.includes('€')) return 'EUR';
    if (/\bCAD\b|CA\$/i.test(value)) return 'CAD';
    if (/\bAUD\b|A\$/i.test(value)) return 'AUD';
    return '';
  };

  const detectNumberStyle = (value) => {
    const normalized = String(value).replace(/[\s\u00a0\u202f]/g, '').replace(/[^0-9,.-]/g, '');
    const lastDot = normalized.lastIndexOf('.');
    const lastComma = normalized.lastIndexOf(',');
    const decimal = lastComma > lastDot ? ',' : '.';
    return { decimal, group: decimal === ',' ? '.' : ',' };
  };

  const formatCurrency = (value, locale, currency, numberStyle) => {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: window.theme?.settings?.currencyCodeEnabled ? 'code' : 'narrowSymbol'
    });

    return formatter.formatToParts(value).map((part) => {
      if (part.type === 'decimal') return numberStyle.decimal;
      if (part.type === 'group') return numberStyle.group;
      return part.value;
    }).join('');
  };

  const updateSavings = (root = document) => {
    const elements = root.matches?.('[data-market-savings]')
      ? [root]
      : root.querySelectorAll?.('[data-market-savings]') || [];

    elements.forEach((element) => {
      const priceContainer = element.closest('.price');
      const locale = element.dataset.marketLocale || document.documentElement.lang || 'en';
      const label = element.dataset.marketSavingsLabel || 'Save [amount]';
      const displayedPrice = priceContainer?.querySelector('.price__regular')?.textContent;
      const displayedCompareAtPrice = priceContainer?.querySelector('.price__sale')?.textContent;
      const currency = detectCurrency(`${displayedPrice || ''} ${displayedCompareAtPrice || ''}`)
        || window.Shopify?.currency?.active
        || element.dataset.marketCurrency;
      const price = parseLocalizedNumber(displayedPrice || element.dataset.marketPrice);
      const compareAtPrice = parseLocalizedNumber(displayedCompareAtPrice || element.dataset.marketComparePrice);

      if (!currency || !Number.isFinite(price) || !Number.isFinite(compareAtPrice)) return;

      const savings = Math.max(0, compareAtPrice - price);
      const numberStyle = detectNumberStyle(displayedPrice || element.dataset.marketPrice);
      const formattedSavings = formatCurrency(savings, locale, currency, numberStyle);
      const nextText = label.replace('[amount]', formattedSavings);
      if (element.textContent !== nextText) element.textContent = nextText;
    });
  };

  const initialize = () => {
    updateSavings();
    let updateQueued = false;
    new MutationObserver(() => {
      if (updateQueued) return;
      updateQueued = true;
      requestAnimationFrame(() => {
        updateQueued = false;
        updateSavings();
      });
    }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
